// extracted by mini-css-extract-plugin
module.exports = {"list":"ContactList_list__3CHj_","item":"ContactList_item__2AKmN"};